<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">{{ $t("Fnborders") }}</div>
      <div class="mt-3 mb-4">
        <div class="row">
          <!-- <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedCinema && selectedCinema.length > 0 ? 'shift-up' : ''
                "
                > {{ $tc("cinema", 1) }}</label
              >
              <b-dropdown
                :disabled="isRoleID"
                :text="selectedCinema"
                name="selectcinema"
                id="selectcinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  href="#"
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelect($event, Cinema, 'Cinema')"
                  >{{ Cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div> -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :multiple="true"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="date"
                  v-on:click="date = null"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="date"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  typeable
                  v-validate="'required'"
                  @selected="onChangeDate($event, 'from')"
                ></Datepicker>
                <!-- @input="onGetTransactionList()" -->
                <label :class="date ? 'active' : ''">{{
                  $t("From Date")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="input-material">
              <div class="add-datepicker">
                <button
                  class="btn-clearDate"
                  v-if="toDate"
                  v-on:click="toDate = null"
                >
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  name="selectenddate_1"
                  id="selectenddate_1"
                  typeable
                  v-validate="'required'"
                ></Datepicker>
                <!-- @input="onGetTransactionList()" -->
                <label :class="toDate ? 'active' : ''">{{
                  $t("To Date")
                }}</label>
              </div>
            </div>
          </div>

          <!-- <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedBookingSource && selectedBookingSource.length > 0
                    ? 'shift-up'
                    : ''
                "
                > {{ $tc("bookingsource", 1) }}</label
              >
              <b-dropdown
                :text="selectedBookingSource"
                name="selectbookingsource"
                id="selectbookingsource"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(booking, bookingIndex) in BookingSourceList"
                  :key="bookingIndex"
                  v-on:click="onSelect($event, booking, 'BookingSource')"
                  >{{ booking.bs_source }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div> -->
          <div class="col-lg-4 col-xl-3 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedBookingSource && selectedBookingSource.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("bookingsource", 1) }}</label
              >
              <b-dropdown
                :text="selectedBookingSource || 'Select Booking Source'"
                name="selectbookingsource"
                id="selectbookingsource"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  @click="
                    onSelect(
                      $event,
                      { bs_source: 'All', bs_id: 0 },
                      'BookingSource'
                    )
                  "
                  >All</b-dropdown-item
                >
                <b-dropdown-item
                  href="#"
                  v-for="(booking, bookingIndex) in BookingSourceList"
                  :key="bookingIndex"
                  @click="onSelect($event, booking, 'BookingSource')"
                  >{{ booking.bs_source }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :class="
                  selectedStatus && selectedStatus.length > 0 ? 'shift-up' : ''
                "
                >{{ $tc("status", 1) }}</label
              >
              <b-dropdown
                :text="selectedStatus"
                name
                id
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  href="#"
                  v-for="(status, statusIndex) in fnbOrderStatus"
                  :key="statusIndex"
                  v-on:click="onSelect($event, status, 'OrderStatus')"
                  >{{ status }}</b-dropdown-item
                >
              </b-dropdown>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              :disabled="btenable"
              @click.prevent="GetTransactionList('N', 'N')"
              class="btn-blue-lg w-100"
            >
              {{ $tc("fetch") }}
            </button>
          </div>

          <div
            v-if="transactionList.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="GetTransactionList('Y', 'N')"
              title="Download as Excel"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="GetTransactionList('N', 'Y')"
              title="Download as PDF"
              download
              style="cursor: pointer;"
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>

      <div
        v-if="transactionList && transactionList.length > 0"
        class="text-right mb-2"
      >
        <b-dropdown id="listview" variant="outline-blue">
          <template v-slot:button-content>
            Viewing&nbsp;
            <strong>{{ selectedvalue }}</strong>
            &nbsp;Of&nbsp;
            <strong>{{ rows }}</strong>
          </template>
          <b-dropdown-item
            v-for="(list, listIndex) in viewingnumbers"
            :key="listIndex"
            @click="onDropDownChangeValue(list.name)"
            href="#"
            >{{ list.name }}</b-dropdown-item
          >
        </b-dropdown>
      </div>

      <div class="swc-report">
        <table class="swc-report-table" border="1">
          <thead class="bg-lightgrey font-weight-bold">
            <tr>
              <th>{{ $tc("order") }} {{ $tc("code") }}</th>
              <th>Order Type</th>
              <th>Delivey / Pickup Time</th>
              <th>{{ $tc("cinema") }} {{ $tc("name") }}</th>
              <th>{{ $tc("screen") }} {{ $tc("name") }}</th>
              <th>{{ $tc("movie") }} {{ $tc("name") }}</th>
              <th>{{ $tc("show") }} {{ $tc("time") }}</th>
              <th>{{ $tc("seat") }} {{ $tc("number") }}</th>
              <th>
                {{ $tc("item") }} {{ $tc("name") }} ({{ $tc("quantity") }})
              </th>
              <th>Booking Source</th>
              <th>Customer Name</th>
              <th>Customer Mobile</th>
              <th>Customer Email</th>
              <th>{{ $tc("revenue") }}</th>
              <!-- <th>{{ $tc("bookingsource") }}</th> -->
              <th>
                {{ $tc("transaction") }} {{ $tc("date") }} & {{ $tc("time") }}
              </th>
              <th>{{ $tc("payment") }} {{ $tc("mode") }}</th>
              <th>{{ $tc("offer") }}</th>
              <!-- <th>
                {{ $tc("delivery") }} {{ $tc("date") }} & {{ $tc("time") }}
              </th> -->
              <th>{{ $tc("delivery") }} {{ $tc("status") }}</th>
              <!-- <th>{{ $tc("view") }} {{ $tc("details") }}</th> -->
            </tr>
          </thead>
          <tbody
            v-for="(fnbtrans, fnbtransIndex) in transactionList"
            :key="fnbtransIndex"
            class="sph-report"
          >
            <tr>
              <td class="text-right">{{ fnbtrans.order_code }}</td>
              <td class="text-right">
                <div
                  class="orderTypeBox"
                  :class="
                    fnbtrans['order_type'] == 'Self Pickup'
                      ? 'pickupbox'
                      : 'deliveryBox'
                  "
                  >{{ fnbtrans["order_type"] || "-" }}</div
                >
              </td>
              <td class="text-right">
                {{ fnbtrans["order_delivery_time"] || "-" }}
              </td>
              <td class="text-left">{{ fnbtrans.ft_cinema_name }}</td>
              <td class="text-left">
                {{
                  fnbtrans.body_json && fnbtrans.body_json.seat_drop_screen
                    ? fnbtrans.body_json.seat_drop_screen
                    : "-"
                }}
              </td>
              <td class="text-left">
                {{
                  fnbtrans.body_json && fnbtrans.body_json.seat_drop_movie
                    ? fnbtrans.body_json.seat_drop_movie
                    : "-"
                }}
              </td>
              <td class="text-left">
                {{
                  fnbtrans.body_json && fnbtrans.body_json.seat_drop_time
                    ? fnbtrans.body_json.seat_drop_time
                    : "-"
                }}
              </td>
              <td class="text-left">
                {{
                  fnbtrans.body_json && fnbtrans.body_json.seat_drop_label
                    ? fnbtrans.body_json.seat_drop_label
                    : "-"
                }}
              </td>
              <td class="text-left">{{ fnbtrans.item_with_quantity }}</td>
              <td class="text-left">{{ fnbtrans.fst_booking_source }}</td>
              <td class="text-left">{{ fnbtrans.customer_name || "-" }}</td>
              <td class="text-left">{{ fnbtrans.cust_mobile || "-" }}</td>
              <td class="text-left">{{ fnbtrans.cust_email || "-" }}</td>
              <td class="text-right">
                {{ fnbtrans.ft_total_amount.toFixed(MIN_FRACTION_DIGITS) }}
              </td>
              <!-- <td class="text-left">{{ fnbtrans.fst_booking_source }}</td> -->
              <td class="text-right">{{ dateParse(fnbtrans.ft_date_time) }}</td>
              <td class="text-left">{{ fnbtrans.pm_payment_mode }}</td>

              <td class="text-left">
                {{ fnbtrans.ft_offer_name ? fnbtrans.ft_offer_name : "-" }}
              </td>
              <!-- <td class="text-right">{{
                fnbtrans.fnb_pickup_time
                  ? dateParse(fnbtrans.fnb_pickup_time)
                  : "-"
              }}</td> -->
              <td
                class="text-left"
                :class="{
                  'text-green': fnbtrans.fat_status === 'Delivered',
                  'text-red': fnbtrans.fat_status === 'Pending'
                }"
              >
                {{ fnbtrans.fat_status ? fnbtrans.fat_status : "-" }}
              </td>
              <!-- <td>
                <button @click="toDetails(fnbtrans)" class="btn-blue">
                  View More
                </button>
              </td> -->
            </tr>
          </tbody>
          <tfoot v-if="transactionList.length > 0">
            <tr class="bg-lightgrey">
              <td class="text-left"><strong>Total</strong></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td class="text-right">
                <strong>
                  {{
                    transactionList
                      .reduce(
                        (acc, fnbtrans) =>
                          acc + (fnbtrans.ft_total_amount || 0),
                        0
                      )
                      .toFixed(MIN_FRACTION_DIGITS)
                  }}
                </strong>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
          <tbody>
            <tr>
              <td v-if="transactionList.length == 0" colspan="13">
                <!-- <p class="text-center mb-0 h6">{{ $tc("NoRecords") }}</p> -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService";
import PosFnbService from "@/services/PosFnbService";
import MasterService from "@/services/MasterService";
import moment from "moment-timezone";
import DatePicker from "vue2-datepicker";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: { DatePicker, NoRecords },
  data() {
    return {
      dropDown: {
        cinemas: [],
        selectedCinema: [],
        selectedCinemaName: null,
        selectedCinemaId: ""
      },
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      isRoleID: true,
      transactionList: [],
      selectedCinema: "",
      cine_id: null,
      Cinemas: [],
      BookingSourceList: [],
      selectedBookingSource: "",
      bs_id: null,
      date: new Date(),
      toDate: new Date(),
      fnbOrderStatus: ["All", "Pending", "Complete", "Delivered"],
      selectedStatus: "Pending",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10"
    };
  },
  beforeMount() {
    this.getviewingnumber();

    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
      this.getCinemaList(obj);
    } else {
      this.getCinemaList(obj);
    }

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    this.getCinemaList();
    // if (CinemaObj) {
    //   this.onSelect(null, CinemaObj, "Cinema");
    // }
    this.GetBookingSources();
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelect(null, CinemaObj, "Cinema");
    //   }
    // }
  },
  methods: {
    onChangeDate: function(e, type) {
      if (type == "from") {
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    onSelectCinema: function(event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaAddress = event.cine_address;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getCinemaList: function() {
      MasterService.GetCinemasByRoles()
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.GetTransactionList();
      } else {
        this.currentPage = event;
        this.GetTransactionList();
      }
    },
    dateParse(date) {
      return moment(date).format("DD-MMM-YYYY HH:mm");
    },
    toDetails(object) {
      this.$router.push({
        name: "View F&B App Transaction",
        params: { ft_id: object.ft_id }
      });
    },
    // getCinemaList: function(cine_id) {
    //   this.Cinemas = [];
    //   // let payload = {
    //   //   tableName: "ms_cinemas",
    //   //   cine_is_active: "Y"
    //   // };
    //   MasterService.GetCinemasByRoles({ cine_id: cine_id })
    //     .then(response => {
    //       const { data } = response;
    //       if (data.status && data.Records && data.Records.length > 0) {
    //         this.Cinemas = data.Records;
    //         this.CinemasCopy = data.Records;

    //         this.Cinemas.map(x => {
    //           if (String(cine_id) === String(x.cine_id)) {
    //             this.selectedCinema = x.cine_name;
    //             this.cine_id = x.cine_id;
    //           }
    //         });
    //       } else {
    //         this.$toasted.show(data.message);
    //       }
    //     })
    //     .catch(this._CatchError);
    // },
    GetBookingSources: function() {
      PosFnbService.BookingSources()
        .then(response => {
          const { data } = response;

          if (data.status) {
            if (data.Records && data.Records.length > 0) {
              //   this.BookingSourceList = data.Records;
              data.Records.map(x => {
                if (x.bs_id == 7 || x.bs_id == 6)
                  this.BookingSourceList.push(x);
              });
              console.log(
                "this.BookingSourceList :>> ",
                this.BookingSourceList
              );
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    // onSelect: function(event, params, type) {
    //   if (type == "Cinema") {
    //     this.selectedCinema = params.cine_name;
    //     this.cine_id = params.cine_id;
    //     this.searchCinema = "";
    //     this.onSearchCinema();
    //     this.$store.dispatch("selectDropdownCinema", params);
    //   } else if (type == "BookingSource") {
    //     this.selectedBookingSource = params.bs_source;
    //     this.bs_id = params.bs_source;
    //   } else if (type == "OrderStatus") {
    //     this.selectedStatus = params;
    //   }
    // },

    onSelect: function(event, params, type) {
      if (type == "Cinema") {
        this.selectedCinema = params.cine_name;
        this.cine_id = params.cine_id;
        this.searchCinema = "";
        this.onSearchCinema();
        this.$store.dispatch("selectDropdownCinema", params);
      } else if (type == "BookingSource") {
        if (params.bs_source === "All") {
          this.selectedBookingSource = "All";
          this.bs_id = null; // Handle the 'All' case appropriately
          // Fetch and display all data since "All" is selected
          this.fetchAllBookingSources();
        } else {
          this.selectedBookingSource = params.bs_source;
          this.bs_id = params.bs_source;
          // Fetch data for the specific booking source
          this.fetchBookingSourceData(params.bs_id);
        }
      } else if (type == "OrderStatus") {
        this.selectedStatus = params;
      }
    },

    //     GetTransactionList: function() {
    //       // this.btenable = true;
    //       let role_is_cinema_level = this.secureStore.get("USINFO")
    //         .cinema_id;
    //         if (role_is_cinema_level && !this.dropDown.selectedCinema.length) {
    //         return this.$toasted.show("Select Cinema");
    //       }
    //       let loader = this.$loading.show();

    //       let payload = {
    //         cinema_id: this.dropDown.selectedCinema && this.dropDown.selectedCinema.length ? this.dropDown.selectedCinema.map(cinemasObj => {
    //           return cinemasObj.cine_id
    //         }) : [],
    //         limit: this.perPage,
    //         currentPage: this.currentPage,
    //         date: this.date,
    //         cinema_id: this.cine_id,
    //         bs_id: this.bs_id,
    //         selectedStatus: this.selectedStatus
    //       };
    //       PosFnbService.GetFnBAppTransactions(payload)
    //         .then(response => {
    //           this.btenable = false;
    //           const { data } = response;

    //           if (data && data.status) {
    //             if (data.Records && data.Records.length > 0) {
    //               this.transactionList = data.Records;
    //               this.transactionList = data.Records.sort((a, b) => {
    //   if (a.fat_status === "Pending" && b.fat_status !== "Pending") {
    //     return -1;
    //   } else if (a.fat_status !== "Pending" && b.fat_status === "Pending") {
    //     return 1;
    //   }
    //   return 0;
    // });
    //               if (data.totalRows >= 10) {
    //                 this.rows = data.totalRows;
    //                 this.selectedvalue =
    //                   this.selectedvalue < 10 ? 10 : this.selectedvalue;
    //               } else {
    //                 this.rows = data.totalRows;
    //                 this.selectedvalue = data.totalRows;
    //               }
    //             } else {
    //               this.transactionList = [];
    //               this.$toasted.show("No Records Found");
    //             }
    //           } else {
    //             this.transactionList = [];
    //             this.$toasted.show(data.message);
    //           }
    //         })
    //         .catch(this._CatchError)
    //         .finally(() => {
    //           setTimeout(() => loader.hide(), 1000);
    //         });
    //     }
    GetTransactionList: function(isExcel = "N", isPdf = "N") {
      // this.btenable = true;
      let role_is_cinema_level = this.secureStore.get("USINFO").cinema_id;

      if (role_is_cinema_level && !this.dropDown.selectedCinema.length) {
        return this.$toasted.show("Select Cinema");
      }

      let loader = this.$loading.show();
      let selectedCinemaNames = this.dropDown.selectedCinema.map(
        cinemasObj => cinemasObj.cine_name
      );
      let selectedCinemaAddress = this.dropDown.selectedCinema.map(
        cinemasObj => cinemasObj.cine_address
      );
      let payload = {
        cinema_address: selectedCinemaAddress || [],
        cinema_name:
          selectedCinemaNames || this.dropDown.selectedCinemaName || "",
        cinema_id: this.dropDown.selectedCinema.length
          ? this.dropDown.selectedCinema.map(cinemasObj => cinemasObj.cine_id)
          : this.cine_id
          ? [this.cine_id]
          : [],
        limit: this.perPage,
        currentPage: this.currentPage,
        date: moment(this.date).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        bs_id: this.bs_id,
        selectedStatus: this.selectedStatus,
        isPdf,
        isExcel
      };

      PosFnbService.GetFnBAppTransactions(payload)
        .then(response => {
          this.btenable = false;
          const { data } = response;

          if (data && data.status) {
            if (data.Records && data.Records.length > 0) {
              this.transactionList = data.Records.sort((a, b) => {
                // if (a.fat_status === "Pending" && b.fat_status !== "Pending") {
                //   return -1;
                // } else if (a.fat_status !== "Pending" && b.fat_status === "Pending") {
                //   return 1;
                // }

                if (a.ft_cinema_name < b.ft_cinema_name) {
                  return -1;
                } else if (a.ft_cinema_name > b.ft_cinema_name) {
                  return 1;
                }

                return 0;
              });

              this.transactionList.forEach(elem => {
                return (elem["body_json"] = elem["body_json"]
                  ? JSON.parse(elem["body_json"])
                  : {});
              });

              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
                this.selectedvalue =
                  this.selectedvalue < 10 ? 10 : this.selectedvalue;
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.transactionList = [];
              this.$toasted.show("No Records Found");
            }
          } else {
            this.transactionList = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    }
  }
};
</script>

<style scoped>
.sph-report th,
td {
  height: 30px;
}

.text-green {
  color: green;
}

.text-red {
  color: red;
}

.orderTypeBox {
  padding: 5px;
  min-width: 100px;
  text-align: center;
  padding-inline: 10px;
  border: 1px solid lightgrey;
  border-radius: 5px;
  font-weight: 500;
  color: black;
}

.deliveryBox {
  background: yellow;
}

.pickupbox {
  background: rgb(138, 185, 240);
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/FnBOrdersComponent/FnbOrders.vue